module.exports = __webpack_public_path__ + "img/font-size.21f264b7.svg";